<template>
  <el-dialog width="60%" :title="$t('m.femsNotice.femsNotice')" :visible.sync="showDialog"
    @close="closeDialog" :before-close="beforeClose" :close-on-click-modal="false" :append-to-body="true" v-dialogDrag>
    <el-form ref="formRef" :rules="formRules" :model="formModel" :disabled="currentAction.value >= 3" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('m.femsNotice.title')" prop="title">
            <el-input v-model="formModel.title" maxlength="90" :placeholder="$t('c.form.maximumLength') + '90'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('m.femsNotice.originator')" prop="receivers">
            <el-input v-model="formModel.originator" autosize type="textarea" maxlength="400" :placeholder="$t('c.form.maximumLength') + '400'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">

        <el-col :span="24">
          <el-form-item :label="$t('m.femsNotice.message')" prop="message">
            <el-input v-model="formModel.message" autosize type="textarea" maxlength="800" :placeholder="$t('c.form.maximumLength') + '800'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="currentAction.value < 3" @click="saveForm()" type="primary">{{ $t('c.dialog.save') }}</el-button>
      <el-button @click.native="closeDialog()">{{ $t('c.dialog.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  insertFemsNotice,
  updateAllColumnFemsNotice
} from '../../api/notice/FemsNotice';
export default {
  name: 'femsNoticeFemsNoticeComp',
  // 组件属性对象
  props: {
    noticeTypeDicts: Array,
    statusDicts: Array,
    generationModeDicts: Array,
    orgTypeDicts: Array,
    // 同步更新父对象的属性, 是否显示该对话框
    detailDialogVisible: Boolean,
    // 来自父组件的操作类型参数
    actionOfParent: Object,
    // 当前主表行记录
    currentTableRow: Object
  },
  // 组件数据对象
  data() {
    return {
      // 是否显示该对话框
      showDialog: true,
      // 表单模型
      formModel: {},
      // 当前操作类型, ACTION.NEW/ACTION.EDIT/ACTION.VIEW
      currentAction: {},
      // 表单验证规则
      formRules: {
        title: [
          { required: true, message: this.$t('c.form.pleaseInput'), trigger: 'blur' }
        ],
        message: [
          { required: true, message: this.$t('c.form.pleaseInput'), trigger: 'blur' }
        ],
        noticeType: [
          { required: true, message: this.$t('c.form.pleaseSelect'), trigger: 'blur' }
        ],
        receivers: [
          { required: true, message: this.$t('c.form.pleaseInput'), trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: this.$t('c.form.pleaseInput'), trigger: 'blur' }
        ],
        endDate: [
          { required: true, message: this.$t('c.form.pleaseInput'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('c.form.pleaseSelect'), trigger: 'blur' }
        ],
        generationMode: [
          { required: true, message: this.$t('c.form.pleaseSelect'), trigger: 'blur' }
        ],
        orgType: [
          { required: true, message: this.$t('c.form.pleaseSelect'), trigger: 'blur' }
        ],
        confirmReceived: [
          { required: true, message: this.$t('c.form.pleaseInput'), trigger: 'blur' }
        ],
        delete_this_line: []
      }
    };
  },
  // 页面首次加载数据
  mounted() {
    this.formModel = this.currentTableRow;
    this.currentAction = this.actionOfParent;
  //  console.log(this.formModel);
  },
  methods: {
    /**
     * 保存表单
     */
    saveForm() {
      this.$refs
        .formRef.validate(valid => {
          if (!valid) {
            this.$message({
              type: 'error',
              message: this.$t('c.form.formMissInfo')
            });
            return;
          }
          // 表单校验成功
          if (this.currentAction.value === 1) {
            this.insert();
          } else {
            this.updateAllColumn();
          }
        });
    },
    /**
     * 新增插入记录
     */
    async insert() {
      let result = null;
      result = await insertFemsNotice(this.formModel);
      if (result.code === 20000) {
        this.closeDialog(true);
      }
    },
    /**
     * 全部字段覆盖更新
     */
    async updateAllColumn() {
      let result = null;
      result = await updateAllColumnFemsNotice(this.formModel);
      if (result.code === 20000) {
        this.closeDialog(true);
      }
    },
    /**
     * 关闭对话框
     * @param modified 是否有更新
     */
    closeDialog(modified) {
      if (this.beforeCloseCheck()) {
        this.showDialog = false;
        // 子组件向父组件绑定的属性传值
        this.$emit('update:detailDialogVisible', false)
        if (modified) {
          this.$emit('listenToDetailDialogClose', this.currentAction)
        }
      }
    },
    /**
     * 对话框关闭前的校验
     * @returns true表示校验通过可以关闭, false表示校验失败不允许关闭
     */
    beforeCloseCheck() {
      // 你的业务校验代码
      return true;
    },
    /**
     * 对话框右上角的×关闭前事件
     * @param done 回调关闭方法
     */
    beforeClose(done) {
      if (this.beforeCloseCheck()) {
        done();
      }
    }
  }
};
</script>

<style lang="scss"></style>
